export default () => {
    
    const topbarNavExpander = document.querySelector('.topbar-nav-toggle');

    if (!topbarNavExpander) {
        return;
    }

    const topbarWrapper = topbarNavExpander.closest('.topbar-nav');

    topbarNavExpander.addEventListener('click', () => topbarWrapper.classList.toggle('topbar-nav--active'));

}
